export enum IssueActionProgressEnum {
  BLANK = 'blank',
  NOT_INITIATED = 'not-initiated', // all in draft
  INITIATED = 'initiated', // some open
  ONGOING = 'ongoing', // some in progress
  COMPLETED = 'completed', // all completed
  DISCARDED = 'discarded', // all discarded
}

export type IssueActionProgressType = `${IssueActionProgressEnum}`;
